import { SpinnerInner } from './spinner';

const SmallSpinner = (props) => (
  <SpinnerInner {...props} big={false} />
);

export default SmallSpinner;
